import { mapActions } from 'vuex'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ServiceDropboxSelector',
  props: {
    name: {
      type: String,
      require: true
    },
    serviceId: {
      type: String,
      require: true
    },
    index: {
      type: Number,
      require: false,
      default: 0
    },
    model: {
      type: Object,
      require: false,
      'default': () => {
        return {
          fileType: '',
          serviceDropboxUuid: null
        }
      }
    },
    // ファイルタイプを固定するときはファイルタイプキーを入れる
    fixedFileType: {
      type: Number,
      require: false,
      'default': () => 0
    },
    // 特定のファイルタイプを非表示にする場合はファイルタイプキーを配列で入れる
    ignoreFileTypes: {
      type: Array,
      require: false,
      'default': () => []
    }
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      loading: true,

      // input
      input: {
        fileType: '',
        serviceDropboxUuid: null,
      },

      // model
      dropboxModel: []
    }
  },
  computed: {
    // list
    dropboxFileTypeList () {
      return Constants.Service.DropboxDataKbn.filter(item => this.ignoreFileTypes.indexOf(item.value) === -1)
    },
    serviceDropboxList () {
      console.log('@@', this.input);
      let list = []
      this.dropboxModel
        .filter(item => item.dataKbn === this.input.fileType)
        .forEach(item => list.push({
          value: item.serviceDropboxUuid,
          label: item.dropboxName
        }))
      return list
    }
  },
  watch: {
    value (to) {
      // 1画面に複数のモジュールが設置された場合の識別処理
      if (to && this.buttonId === this.name) {
        // console.log(this.name, to)
        this.changeScreen(to)
      }
    },
    'input.fileType' (to, from) {
      if (from === '') return
      this.input.serviceDropboxUuid = null
      // this.loadDropboxList()
    },
  },
  methods: {
    ...mapActions({
      showError: 'error/show'
    }),

    init () {
      if (this.model) {
        let data = $.extend(true, this.input, this.model)
        this.$set(this, 'input', data)
      }

      this.loadDropboxList()
    },

    loadDropboxList () {
      // Dropboxデータを取得
      this.loading = true

      // TODO ファイルタイプで絞り込みが出来るようになったら修正
      ApiManager.request(
        ['serviceDropbox'],
        ['v1ServiceDropboxListGet'],
        [{
          serviceUuid: this.serviceId
        }])
        .then(res => {
          this.loading = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            this.dropboxModel = res[0].data.serviceDropboxSettings
            console.log('dropboxModel', this.dropboxModel)

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.loading = false
          this.showError(null)
        })
    },

    changeValue () {
      this.$emit('childs-change', {
        name: this.name,
        index: this.index,
        value: this.input
      })
    }
  }
}